<template>
    <div>
        <breadcrumb :links="[{ text: '使用條款' }]" />
        <termsOfUseContent />
    </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb.vue';
import termsOfUseContent from '@/components/termsOfUseContent.vue';

export default {
    components: {
        breadcrumb,
        termsOfUseContent
    }
};
</script>
